var React = require('react');

function CheckEmpty (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_117","data-name":"Group 117","transform":"translate(-1028 -233)"},React.createElement("circle",{"id":"Ellipse_1","data-name":"Ellipse 1","fill":"none","stroke":"#bcbcbc","strokeWidth":"1","cx":"9.5","cy":"9.5","r":"9","transform":"translate(1028 233)"})));
}

CheckEmpty.defaultProps = {"viewBox":"0 0 19 19"};

module.exports = CheckEmpty;

CheckEmpty.default = CheckEmpty;
